<div class="flex-column gap-m">
    <div *ngFor="let group of groups">
        <dashlet-section-header>{{ group.name }}</dashlet-section-header>
        <div class="flex-wrap gap-l group">
            <app-dashlet-tile *ngFor="let dashlet of group.dashlets" [dashlet]="dashlet" (addDashlet)="addDashlet(dashlet)"> </app-dashlet-tile>
        </div>
    </div>
</div>
